import { z } from 'zod';

import { AccessRestrictionMode, PeoStaffRole } from 'src/api';

import {
  AccessRestrictionModeFormField,
  accessRestrictionModeFormValidationSchema,
} from '../../AccessRestrictionModeFormPart';
import { InviteFormFields, InviteFormFieldsForStaff } from '../constants';
import { InviteFormFieldsValues } from '../types';

export const inviteFormValidationSchema = z.object({
  [InviteFormFields.staff]: z
    .array(
      z
        .object({
          [InviteFormFieldsForStaff.email]: z.email('Invalid email').nonempty('Required'),
          [InviteFormFieldsForStaff.businessRole]: z.enum(PeoStaffRole),
          [AccessRestrictionModeFormField.accessRestrictionMode]: z.enum(AccessRestrictionMode),
        })
        .and(accessRestrictionModeFormValidationSchema),
    )
    .min(1, 'At least one staff member is required'),
}) satisfies z.ZodType<InviteFormFieldsValues>;
